import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import {useTheme} from '@material-ui/core/styles';
import FabCountdownButton from "../../framework/util/uicomps/progress/FabCountdownButton";
import Grid from "@material-ui/core/Grid";
import PalletSummary from "../presspalletbuilder/palletsummary/PalletSummary";

const useStyles = makeStyles((theme) => ({
    root: {
        // maxWidth: 345
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    media: {
        // height: 140,
    },
}));


export default function DashWidget({title, subtitle, msg, details, Icon, actions=[], avatar, showRefresh=false, onRefreshFunc, refreshSeconds=1* 60}, {...props}) {

    const theme = useTheme();
    const classes = useStyles();
    var avatarToUse = !avatar ?  (<Avatar className={classes.avatar}>{Icon}</Avatar>) : avatar;

    // Override avatar if this item is self refereshing
    if (showRefresh) {
       avatarToUse =  (<FabCountdownButton immediate={true} refreshFunc={onRefreshFunc} seconds={refreshSeconds}
                                          RefreshIconOverride={()=>Icon} className={classes.refreshFab}/>);
    }


    const wrappedRefreshButton = (<Grid container
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
    >

    </Grid>);

    return (
        <div>
        <Card className={classes.root}>
            <CardHeader
                avatar={
                    avatarToUse
                }
                title={(<Typography variant="h6" color="textSecondary" component="p">{title}</Typography>)}
                subheader={subtitle}
            />
            <CardActionArea>
                <CardContent>
                    <Typography variant="body2" color="textSecondary" component="p">
                        {msg}
                    </Typography>
                    {details}
                </CardContent>
            </CardActionArea>
            <CardActions>
                {actions}
            </CardActions>
        </Card>
        </div>
    );
}